// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messages-shell {
  display: flex;
  height: calc(100vh - 140px);
  background: var(--color-light);
  border: 1px solid var(--color-border);
  border-radius: 10px;
  overflow: hidden;
}

.messages-list {
  width: 280px;
  flex-shrink: 0;
  border-right: 1px solid var(--color-border);
  overflow-y: auto;
}

.thread-item {
  display: block;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  border-bottom: 1px solid var(--color-border);
  padding: 12px 16px;
}
.thread-item.active, .thread-item:hover {
  background: var(--color-bg-light);
}
.thread-item .thread-name {
  font-weight: 600;
  font-size: 14px;
}
.thread-item .thread-top,
.thread-item .thread-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
}
.thread-item .thread-time {
  font-size: 11px;
  color: var(--gray-500);
  flex-shrink: 0;
}
.thread-item .thread-preview {
  font-size: 12px;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
.thread-item .thread-unread {
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: var(--color-accent);
  color: #000;
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.messages-thread {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.thread-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.thread-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.chat-bubble {
  max-width: 60%;
  background: var(--color-bg-light);
  border-radius: 12px;
  padding: 8px 12px;
  align-self: flex-start;
}
.chat-bubble.mine {
  align-self: flex-end;
  background: var(--color-accent);
}
.chat-bubble .chat-bubble-time {
  font-size: 10px;
  margin-top: 2px;
}

.thread-input {
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid var(--color-border);
}
.thread-input input {
  flex: 1 1;
}

.messages-shell {
  margin-top: 24px;
  border-radius: 14px;
  border-color: var(--gray-200);
}

.messages-list-head {
  padding: 16px;
  font-size: 18px;
  font-weight: 700;
  border-bottom: 1px solid var(--color-border);
}

.thread-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--color-border);
}

@media (max-width: 768px) {
  .messages-shell {
    margin: -16px -16px 0;
    border: none;
    border-radius: 0;
    height: calc(100dvh - 56px - 64px - env(safe-area-inset-bottom) - env(safe-area-inset-top));
  }
  .messages-list {
    width: 100%;
    border-right: none;
  }
  .messages-thread {
    display: none;
  }
  .messages-shell.show-thread .messages-list {
    display: none;
  }
  .messages-shell.show-thread .messages-thread {
    display: flex;
  }
  .thread-item {
    padding: 14px 16px;
  }
  .chat-bubble {
    max-width: 80%;
  }
  .thread-input {
    padding: 10px 12px;
  }
  .thread-input .btn-accent-solid {
    width: 46px;
    padding: 0;
    border-radius: 50%;
    flex-shrink: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Messages/Messages.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,2BAAA;EACA,8BAAA;EACA,qCAAA;EACA,mBAAA;EACA,gBAAA;AACD;;AAEA;EACC,YAAA;EACA,cAAA;EACA,2CAAA;EACA,gBAAA;AACD;;AAEA;EACC,cAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,4CAAA;EACA,kBAAA;AACD;AACC;EAEC,iCAAA;AAAF;AAGC;EACC,gBAAA;EACA,eAAA;AADF;AAIC;;EAEC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,YAAA;AAFF;AAKC;EACC,eAAA;EACA,sBAAA;EACA,cAAA;AAHF;AAMC;EACC,eAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;AAJF;AAOC;EACC,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,+BAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AALF;;AASA;EACC,SAAA;EACA,aAAA;EACA,sBAAA;AAND;;AASA;EACC,aAAA;EACA,sBAAA;EACA,YAAA;AAND;;AASA;EACC,SAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAND;;AASA;EACC,cAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;AAND;AAQC;EACC,oBAAA;EACA,+BAAA;AANF;AASC;EACC,eAAA;EACA,eAAA;AAPF;;AAWA;EACC,aAAA;EACA,QAAA;EACA,kBAAA;EACA,yCAAA;AARD;AAUC;EACC,SAAA;AARF;;AAYA;EACC,gBAAA;EACA,mBAAA;EACA,6BAAA;AATD;;AAYA;EACC,aAAA;EACA,eAAA;EACA,gBAAA;EACA,4CAAA;AATD;;AAYA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,4CAAA;AATD;;AAYA;EAEC;IACC,qBAAA;IACA,YAAA;IACA,gBAAA;IACA,2FAAA;EAVA;EAaD;IACC,WAAA;IACA,kBAAA;EAXA;EAcD;IACC,aAAA;EAZA;EAgBA;IACC,aAAA;EAdD;EAgBA;IACC,aAAA;EAdD;EAkBD;IACC,kBAAA;EAhBA;EAmBD;IACC,cAAA;EAjBA;EAoBD;IACC,kBAAA;EAlBA;EAoBA;IACC,WAAA;IACA,UAAA;IACA,kBAAA;IACA,cAAA;EAlBD;AACF","sourcesContent":[".messages-shell {\n\tdisplay: flex;\n\theight: calc(100vh - 140px);\n\tbackground: var(--color-light);\n\tborder: 1px solid var(--color-border);\n\tborder-radius: 10px;\n\toverflow: hidden;\n}\n\n.messages-list {\n\twidth: 280px;\n\tflex-shrink: 0;\n\tborder-right: 1px solid var(--color-border);\n\toverflow-y: auto;\n}\n\n.thread-item {\n\tdisplay: block;\n\twidth: 100%;\n\ttext-align: left;\n\tbackground: none;\n\tborder: none;\n\tborder-bottom: 1px solid var(--color-border);\n\tpadding: 12px 16px;\n\n\t&.active,\n\t&:hover {\n\t\tbackground: var(--color-bg-light);\n\t}\n\n\t.thread-name {\n\t\tfont-weight: 600;\n\t\tfont-size: 14px;\n\t}\n\n\t.thread-top,\n\t.thread-bottom {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tgap: 8px;\n\t\tmin-width: 0;\n\t}\n\n\t.thread-time {\n\t\tfont-size: 11px;\n\t\tcolor: var(--gray-500);\n\t\tflex-shrink: 0;\n\t}\n\n\t.thread-preview {\n\t\tfont-size: 12px;\n\t\tmargin-top: 2px;\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\tmin-width: 0;\n\t}\n\n\t.thread-unread {\n\t\tmin-width: 20px;\n\t\theight: 20px;\n\t\tpadding: 0 6px;\n\t\tborder-radius: 10px;\n\t\tbackground: var(--color-accent);\n\t\tcolor: #000;\n\t\tfont-size: 11px;\n\t\tfont-weight: 700;\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tflex-shrink: 0;\n\t}\n}\n\n.messages-thread {\n\tflex: 1;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.thread-panel {\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100%;\n}\n\n.thread-messages {\n\tflex: 1;\n\toverflow-y: auto;\n\tpadding: 16px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 10px;\n}\n\n.chat-bubble {\n\tmax-width: 60%;\n\tbackground: var(--color-bg-light);\n\tborder-radius: 12px;\n\tpadding: 8px 12px;\n\talign-self: flex-start;\n\n\t&.mine {\n\t\talign-self: flex-end;\n\t\tbackground: var(--color-accent);\n\t}\n\n\t.chat-bubble-time {\n\t\tfont-size: 10px;\n\t\tmargin-top: 2px;\n\t}\n}\n\n.thread-input {\n\tdisplay: flex;\n\tgap: 8px;\n\tpadding: 12px 16px;\n\tborder-top: 1px solid var(--color-border);\n\n\tinput {\n\t\tflex: 1;\n\t}\n}\n\n.messages-shell {\n\tmargin-top: 24px;\n\tborder-radius: 14px;\n\tborder-color: var(--gray-200);\n}\n\n.messages-list-head {\n\tpadding: 16px;\n\tfont-size: 18px;\n\tfont-weight: 700;\n\tborder-bottom: 1px solid var(--color-border);\n}\n\n.thread-head {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 10px;\n\tpadding: 10px 12px;\n\tborder-bottom: 1px solid var(--color-border);\n}\n\n@media (max-width: 768px) {\n\t// Full-bleed chat app: list screen, then thread screen\n\t.messages-shell {\n\t\tmargin: -16px -16px 0;\n\t\tborder: none;\n\t\tborder-radius: 0;\n\t\theight: calc(100dvh - 56px - 64px - env(safe-area-inset-bottom) - env(safe-area-inset-top));\n\t}\n\n\t.messages-list {\n\t\twidth: 100%;\n\t\tborder-right: none;\n\t}\n\n\t.messages-thread {\n\t\tdisplay: none;\n\t}\n\n\t.messages-shell.show-thread {\n\t\t.messages-list {\n\t\t\tdisplay: none;\n\t\t}\n\t\t.messages-thread {\n\t\t\tdisplay: flex;\n\t\t}\n\t}\n\n\t.thread-item {\n\t\tpadding: 14px 16px;\n\t}\n\n\t.chat-bubble {\n\t\tmax-width: 80%;\n\t}\n\n\t.thread-input {\n\t\tpadding: 10px 12px;\n\n\t\t.btn-accent-solid {\n\t\t\twidth: 46px;\n\t\t\tpadding: 0;\n\t\t\tborder-radius: 50%;\n\t\t\tflex-shrink: 0;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
